import React from 'react';
import { Select } from '@chakra-ui/react';

const statuses = {
	active: 'Активный',
	contract: 'Контракт отправлен',
	closed: 'Закрыт',
	suspended: 'Приостановлен',
};

export const StatusSelect = ({ onChange, disabled, newStatus }) => (
	<Select name="status" {...{ onChange, disabled }}>
		{Object.keys(statuses).map(key => (
			<option key={key} value={key} selected={key === newStatus}>
				{statuses[key]}
			</option>
		))}
	</Select>
);
